import { getSession } from '../services/storage.service';
import { ROLE_ADMIN, ROLE_CONTROL_DOCUMENT, ROLE_TRADER } from '../config/roles.config';

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  const decoded = decodeURIComponent(escape(window.atob(base64)));

  return JSON.parse(decoded);
};

const getParsedToken = () => {
  const session = getSession();

  return (session) ? parseJwt(session.token) : null;
};

export const getFirstName = () => {
  const decoded = getParsedToken() || {};

  return decoded.firstName || null;
};

export const getLastName = () => {
  const decoded = getParsedToken() || {};

  return decoded.lastName || null;
};

export const getUserHash = () => {
  const decoded = getParsedToken() || {};

  return decoded.sub || null;
};

export const getFullName = () => {
  const firstName = getFirstName() || '';
  const lastName = getLastName() || '';

  return `${ firstName } ${ lastName }`;
};

export const isAdminRole = () => {
  const decoded = getParsedToken();

  return (!!decoded && decoded.role && decoded.role.authority === ROLE_ADMIN);
};

export const isControlDocumentRole = () => {
  const decoded = getParsedToken();

  return (!!decoded && decoded.role && decoded.role.authority === ROLE_CONTROL_DOCUMENT);
};

export const isTraderRole = () => {
  const decoded = getParsedToken();

  return (!!decoded && decoded.role && decoded.role.authority === ROLE_TRADER);
};

export const canAccessSaleOrderEdition = () => {

  return isAdminRole() ||
         isTraderRole();
};

export const canAccessSaleOfferEdition = () => {

  return isAdminRole() ||
    isTraderRole();
};

export const canAccessAdministrator = () => {
  return isAdminRole();
};

export const canAccessDashboard = () => {
  return isAdminRole() ||
        isTraderRole();
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/utils/jwt.utils.ts